import {Cloudinary} from 'cloudinary-core';

export const cloudName = 'demo';
const cloudinaryCore = new Cloudinary({cloud_name: cloudName});

export const assetUrl = (publicId) => cloudinaryCore.url('Product%20gallery%20demo/New%20Demo%20Pages/' + publicId);

const routes = {
  tos: 'https://cloudinary.com/tos',
  privacy: 'https://cloudinary.com/privacy',
  documentation: 'https://cloudinary.com/documentation/product_gallery',
  docReference: 'https://cloudinary.com/documentation/product_gallery_reference',
  learnMore: {
    product: 'https://cloudinary.com/documentation/product_gallery',
    events: 'https://cloudinary.com/documentation/product_gallery',
    transformation: 'https://cloudinary.com/documentation/image_transformations',
  },
};

export default routes;
